module.exports = __webpack_public_path__ + "img/empty.42e4cd3c.svg";